var _defs, _path, _polygon, _rect, _rect2, _path2, _text;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBackRight(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 163 61.08",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#f2f2f2;stroke:#000;stroke-miterlimit:10;}.cls-2{fill:#009cdb;}.cls-3{fill:#191919;}.cls-4{fill:#fff;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M146.87,58.81H2.6L2.75,2H146.87a5.19,5.19,0,0,1,5.18,5.18V53.63A5.19,5.19,0,0,1,146.87,58.81Z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "3.16 2.43 3.01 58.41 39.38 58.38 43.77 58.38 43.77 2.27 40.59 2.27 3.16 2.43"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 42.73,
    y: 2.22,
    width: 2.07,
    height: 56.16
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 30.88,
    y: 6.28,
    width: 7.42,
    height: 48.65,
    transform: "translate(69.17 61.21) rotate(-180)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M38.29,56H30.88a1,1,0,0,1-1-1V6.28a1,1,0,0,1,1-1h7.41a1,1,0,0,1,1,1V54.93A1,1,0,0,1,38.29,56Zm-6.38-2.07h5.35V7.32H31.91Z"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 53,
    y: 35,
    fill: "black",
    fontFamily: "OpenSans-Regular, Open Sans, sans-serif",
    fontSize: "9pt"
  }, "Back right")));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackRight);
export default __webpack_public_path__ + "static/media/back_right.ad03ae40da8d8162cd28929adcc92f15.svg";
export { ForwardRef as ReactComponent };